import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
    Text
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import * as ServerOperations from "../utils/ServerOperations";
import loaderHandler from "../components/react-native-busy-indicator/LoaderHandler";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
const wFactor = 1;
const widths = [285 * wFactor, 90 * wFactor, 90 * wFactor, 105 * wFactor, 98 * wFactor, 90 * wFactor, 60 * wFactor];
let styles = {};
let isMobile = false;
let scale = 1;
const imgProfile = require("../images/Header/Profile.png");
const imgJdsLogo = require("../images/Header/JdsLogo.png");
const closeDesktopIcon = require("../images/ClientHomePage/closeIconDesktop.png");
class InvoiceDetails extends Component {
    constructor(props) {
        super(props);

        this.state = {
            TransactionsItem: [],
            invoiceURL: '',
        };
    }
    Pressables = {};

    async componentDidMount() {
        if (typeof window !== 'undefined' && window.addEventListener) {
            window.addEventListener('popstate', this.handleBackButton);

            // Push current state to history for better navigation
            const currentState = {
                page: 'InvoiceDetails',
                productId: this.props.productID,
                timestamp: Date.now()
            };
            window.history.pushState(currentState, 'Invoice Details', window.location.pathname);
        }

        await this.loadInvoiceDetails();
    }


    componentWillUnmount() {
        // Clean up event listener
        if (typeof window !== 'undefined' && window.removeEventListener) {
            window.removeEventListener('popstate', this.handleBackButton);
        }
    }

    handleBackButton = (event) => {
        // Handle back button press - close product details
        if (this.props.showRetDetails)
            this.props.showRetDetails(false);

        // Prevent default browser back behavior if needed
        // You can remove this if you want normal browser back behavior
        if (event.state && event.state.page === 'InvoiceDetails') {
            // Custom handling - stay on current page but close modal/details
            window.history.pushState(event.state, 'Invoice Details', window.location.pathname);
        }
    }


    loadInvoiceDetails = async () => {
        loaderHandler.showLoader(STRINGS.loading, this.props.self);
        const InvoiceNumber = this.props.RetNumber;
        const InvoiceDate = this.props.RetDate;
        const InvoiceAmount = this.props.RetAmount;

        this.setState({ InvoiceNumber, InvoiceDate, InvoiceAmount });
        let resp = await ServerOperations.getReturns('', '', InvoiceNumber, this.props.RetID);
        console.log('Invoice Details Response:', resp);
        setTimeout(() => {
            let InvoiceAmount = resp.reduce((sum, item) => sum + parseFloat(item.TOTAL), 0);
            InvoiceAmount = InvoiceAmount.toFixed(3);
            this.setState({ TransactionsItem: resp, invoiceURL: resp.URL, InvoiceAmount });
            loaderHandler.hideLoader();
        }, 1000);
    }

    renderHeaderMobile = () => {
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between" }}>
                <TouchableOpacity onPress={() => window.location = './ClientHomePage'}>
                    <Image source={imgJdsLogo} style={{
                        width: 35.063,
                        height: 37,
                        padding: 1,
                        resizeMode: "contain",
                    }} />
                </TouchableOpacity>
                <TouchableOpacity onPress={() => window.location = './profile'}>
                    <Image source={imgProfile} style={{ width: 20, height: 20, stroke: Styles.appColor1 }}></Image>
                </TouchableOpacity>
            </View>
        )
    }


    renderDownloadButtonDesktop = () => {
        return null;
    }
    renderDownloadButton = () => {
        return null;
    }



    renderMobile() {
        scale = width / 420;
        return (
            <View style={styles.container}>
                {this.renderHeaderDialog()}
                {/* <ScrollView */}
                {/* ref={ref => this.mainScrollView = ref} */}
                {/* scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}> */}
                <View style={{ width }}>
                    {Commons.loadFonts(this, false)}
                    {Styles.renderVSeparator(0)}
                    {this.renderPart1Mobile()}
                    {/* {Commons.renderFooter({}, this)} */}
                </View>
                {/* </ScrollView> */}
                <View style={{ position: 'absolute', bottom: 20, right: 20 }}>
                    {this.state.invoiceURL && this.renderDownloadButton()}
                </View>
            </View >
        );
    }

    render() {
        width = Dimensions.get("window").width;
        isMobile = Commons.isMobile();

        if (isMobile) {
            styles = this.styles();
            Commons.resizeHandle(window, this, () => {
                width = this.width;
                height = this.height;
            });
            return this.renderMobile();
        }
        width = Commons.getDesktopWidth();
        height = Commons.getDesktopHeight();
        scale = width / 1126;
        if (scale > 1) scale = 1;
        styles = this.styles();

        const InvoiceHeader = [
            { title: STRINGS.Desktop_Item_Name, width: widths[0] * scale },
            { title: STRINGS.qty, width: widths[1] * scale },
            { title: STRINGS.Desktop_Price, width: widths[2] * scale },
            { title: STRINGS.Desktop_Expiry, width: widths[3] * scale },
            { title: STRINGS.Desktop_Batch, width: widths[4] * scale },
            { title: STRINGS.Desktop_Tax, width: widths[5] * scale },
            { title: STRINGS.Desktop_Total, width: widths[6] * scale },
        ]

        const TransactionsItems = this.state.TransactionsItem.map((item) =>
            <View style={{
                flexDirection: 'row',
                width: 912 * scale,
                justifyContent: 'space-between',
                alignItems: 'center',
                paddingVertical: 20,
                borderBottomColor: 'rgba(0, 0, 0, 0.16)',
                borderBottomWidth: 1.5,
            }}>
                <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[0] * scale }]}>{item.ITEM_CODE}</Text>
                <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[1] * scale }]}>{item.QTY}</Text>
                <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[2] * scale }]}>{item.PRICE}</Text>
                <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[3] * scale }]}>{item.EXP_DATE}</Text>
                <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[4] * scale }]}>{item.BATCH}</Text>
                <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[5] * scale }]}>{item.TAX}</Text>
                <Text style={[AppStyles.BodyTextInvDetailsStyles, { width: widths[6] * scale }]}>{item.TOTAL}</Text>
            </View >
        );

        const showInvoiceDetails = this.props.showRetDetails;

        return (

            <View style={{
                alignItems: 'flex-start',
                minHeight: '100%',
                backgroundColor: AppStyles.desktopBackgroundColor,
            }}>
                <View style={{ gap: 20, flexDirection: 'column', marginLeft: 10 }}>
                    <View style={{ justifyContent: 'space-between', width: 962 * scale, flexDirection: 'row', marginHorizontal: 50, marginTop: 83.93 }}>
                        <Text style={[AppStyles.H2Styles, {}]}>{STRINGS.Return_Details}</Text>
                        <TouchableOpacity style={{ marginTop: 10 }} onPress={() => showInvoiceDetails(false)}>
                            <Image source={closeDesktopIcon} style={{ width: 10, height: 10 }} />
                        </TouchableOpacity>
                    </View>
                    <View style={{ justifyContent: 'space-between', width: 962 * scale, flexDirection: 'row', marginHorizontal: 50, gap: 10 }}>
                        <View style={{ flexDirection: 'column', }}>
                            <Text style={[AppStyles.H3Styles, { color: '#50B0FF', alignSelf: 'stretch' }]}>{this.props.RetNumber}</Text>
                            <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(59, 98, 127, 0.50)', alignSelf: 'stretch', marginTop: 2 }]}>{this.props.RetDate}</Text>
                        </View>
                        <Text style={[AppStyles.BodyTextStyles, { marginTop: 25 }]}>{this.props.RetAmount} <Text style={[AppStyles.JODinvoiceStyle]}>JOD</Text></Text>
                    </View>
                </View>
                <View style={{
                    paddingHorizontal: 40, marginTop: 20, backgroundColor: 'white',
                    borderRadius: 16, paddingBottom: 20,
                    marginLeft: 50,
                    marginTop: 50,
                }}>
                    <View style={{
                        borderTopRightRadius: 16, borderTopLeftRadius: 16,
                        paddingVertical: 20, flexDirection: 'row', justifyContent: 'space-between',
                        borderBottomColor: 'rgba(0, 0, 0, 0.16)',
                        borderBottomWidth: 1.5,
                        width: 912 * scale,
                    }}>
                        {InvoiceHeader.map((header) => {
                            return (
                                <Text style={[AppStyles.tblHeaderStyle, { width: header.width }]}>{header.title}</Text>
                            )
                        })}
                    </View>
                    <ScrollView style={{ height: height - 350 }}>
                        {TransactionsItems}
                    </ScrollView>
                    {this.state.invoiceURL !== '' && this.renderDownloadButtonDesktop()}
                </View>
            </View>
        )
    }


    renderPart1Mobile = () => {
        const TransactionsItems = this.state.TransactionsItem.map((item) =>
            <View style={[AppStyles.InvoiceDetailsMainViewStyle, { width: width - 40, paddingHorizontal: 16, alignSelf: 'stretch' }]}>
                <View style={{ alignItems: 'center', gap: 24, flexDirection: 'row', width: width - 40 }}>
                    <View style={{ flexDirection: 'column', gap: 6, marginTop: 20 }}>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Item</Text>
                        {Commons.getTextWidth(item.ITEM_CODE) > (width - 180) && <Text style={[[AppStyles.InvoiceDetailsItemsStyle]]}>  </Text>}
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Qty</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Price</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Expiry</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle]}>Batch</Text>
                    </View>
                    <View style={{ flexDirection: 'column', gap: 6, marginTop: 20 }}>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400', maxWidth: width - 130 }]}>{item.ITEM_CODE}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{item.QTY}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{item.PRICE}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{item.EXP_DATE}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontWeight: '400' }]}>{item.BATCH}</Text>
                    </View>
                    <View style={{ position: 'absolute', right: 32, flexDirection: 'column', alignItems: 'flex-start', gap: 5, marginTop: 80, width: 100 }}>
                        {item.DISCOUNT > 0 ? <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751 }]}>{STRINGS.discount_2} {item.DISCOUNT}</Text> : <Text></Text>}
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751 }]}>{STRINGS.Tax_invoice} {item.TAX}</Text>
                        <Text style={[AppStyles.InvoiceDetailsItemsStyle, { fontSize: 10.751 }]}>{STRINGS.Total_invoice} {item.TOTAL}</Text>
                    </View>
                </View>
                <Text></Text>
            </View>
        );
        const { showInvoiceDetails } = this.props;

        return (
            <View style={{
                flexDirection: 'column',
                backgroundColor: '#FFF',
                alignItems: 'center',
            }}>
                <View style={{ width: width - 40, flexDirection: 'column', alignItems: 'flex-start', gap: 8, paddingHorizontal: 7 }}>
                    <View style={{ justifyContent: 'space-between', width: width - 40, flexDirection: 'row', }}>
                        <Text style={[AppStyles.H2Styles, {}]}>{STRINGS.Return_Details}</Text>

                    </View>
                    <View style={{ justifyContent: 'space-between', alignItems: 'center', alignSelf: 'stretch', flexDirection: 'row' }}>
                        <View style={{ flexDirection: 'column', gap: 5 }}>
                            <Text style={[AppStyles.H3Styles, { height: 23.943, alignSelf: 'stretch' }]}>{this.state.RetNumber}</Text>
                            <Text style={[AppStyles.BodyTextStyles, { color: 'rgba(59, 98, 127, 0.50)', alignSelf: 'stretch' }]}>{this.state.RetDate}</Text>
                        </View>
                        <View>
                            <Text style={[AppStyles.BodyTextStyles, {}]}>
                                {this.state.RetAmount}{' '}
                                <Text style={[AppStyles.JODinvoiceStyle, {}]}>
                                    JOD
                                </Text>
                            </Text>
                        </View>
                    </View>
                </View>
                <ScrollView style={{ marginTop: 32, gap: 32, flexDirection: 'column', height: height - 200 }} showsVerticalScrollIndicator={false}>
                    {TransactionsItems}
                    <Text style={{ height: 56 }}></Text>
                </ScrollView>
                {/* {this.renderDownloadButton()} */}
            </View>
        )
    }



    renderHeaderDialog = () => {
        return (
            <View style={{ flexDirection: 'row', alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between", height: 75, width }}>
                <TouchableOpacity>
                </TouchableOpacity>

            </View>
        )
    }



    styles = () => ({
        container: {
            flex: 1,
            width: width,
            alignItems: "center",
            backgroundColor: WHITE
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: 590,
        }
    });
}



export default InvoiceDetails;
